import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  return {
    root: {
      margin: 'auto',
      maxWidth: '100%',
      marginBottom: pxToRem(64),
      '& .slick-slider': {
        width: 'calc(100% + 16px)',
        ...theme.mixins.marginLeft(-8),
        '@media (max-width: 1520px)': {
          maxWidth: pxToRem(500),
        },
        [theme.breakpoints.down('lg')]: {
          maxWidth: 'none',
        },
        [theme.breakpoints.down('md')]: {
          width: 'calc(100%)',
          ...theme.mixins.marginLeft(0),
        },
        '@media (max-width: 767px)': {
          width: 'calc(100% + 40px)',
          ...theme.mixins.marginLeft(-18),
        },
        '& .MuiButtonBase-root': {
          width: '100%',
          height: '100%',
          '&:hover': {
            backgroundColor: '#0D746D',
            '& svg': {
              '& path': {
                fill: '#fff'
              }
            },
          },
        },
        '& .slick-next': {
          left: theme.isDirectionRTL ? 'auto' : 'auto',
          right: theme.isDirectionRTL ? '0px' : '0px',
          transform: theme.isDirectionRTL ? "translateY(-50%) translateX(50%)" : "translateY(-50%) translateX(50%)",
          top: '50%',
        },
        '& .slick-prev': {
          left: theme.isDirectionRTL ? '0px' : '0px',
          right: theme.isDirectionRTL ? 'auto' : 'auto',
          transform: theme.isDirectionRTL ? "translateY(-50%) translateX(-50%)" : "translateY(-50%) translateX(-50%)",
          top: '50%',
        },
        '[dir="rtl"] &': {
          direction: 'ltr',
          [theme.breakpoints.down('md')]: {
            direction: 'rtl',
          },
        },
        '& .slick-list': {
          [theme.breakpoints.down('md')]: {
            overflow: 'scroll',
            paddingBottom: `${pxToRem(10)} !important`
          },
          [theme.breakpoints.down('sm')]: {
            padding: `0 !important`,
            paddingBottom: '10px !important',
            paddingLeft: theme.isDirectionRTL ? '24px !important' : '0px',
            paddingRight: theme.isDirectionRTL ? '0px' : '24px !important',
          },
          '& .slick-track': {
            ...theme.mixins.marginLeft(-3),
            '@media (max-width: 1520px)': {
              ...theme.mixins.marginLeft(0),
            },
            [theme.breakpoints.down('md')]: {
              ...theme.mixins.marginLeft(-8),
            },
            '[dir="rtl"] &': {
              [theme.breakpoints.down('md')]: {
                left: '0 !important',
              },
            },
            [theme.breakpoints.down('sm')]: {
              ...theme.mixins.marginLeft(6),
            },
          }
        },
        '& .slick-slide': {
          padding: '2px 8px',
          '@media (max-width: 600px)': {
            padding: '2px 13px',
          },
          '[dir="rtl"] &': {
            direction: 'rtl',
          },
        },
        '& .btns': {
          transition: 'backgroundColor ease 0.25s',
        },
        '& .slick-arrow': {
          boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
          borderRadius: '100px',
          backgroundColor: '#fff',
          width: pxToRem(56),
          height: pxToRem(56),
          zIndex: 2,
          display: 'flex',
          alignItmes: 'center',
          justifyContent: 'center',
          '&:hover': {
            backgroundColor: '#0D746D',
            '& svg': {
              '& path': {
                fill: '#fff'
              }
            },
          },
          [theme.breakpoints.down('1024')]: {
            display: 'none !important'
          },
          '&.slick-disabled': {
            opacity: 0,
            visibility: 'hidden',
            pointerEvents: 'none'
          },
          '& svg': {
            width: pxToRem(24),
            height: pxToRem(16),
            transform: theme.isDirectionRTL ? "rotate(180deg) " : "rotate(0deg) ",

            '[dir="rtl"] &': {
              rotate: '180deg',
            },
            '& path': {
              fill: '#000'
            }
          },
          '&::before': {
            content: "''"
          }
        }
      },
      '& .heading': {
        marginBottom: pxToRem(32),
        '@media (max-width: 768px)': {
          fontSize: pxToRem(26),
          lineHeight: pxToRem(32),
        },

        '@media (max-width: 375px)': {
          fontSize: pxToRem(22),
        },
        [theme.breakpoints.down('md')]: {
          marginBottom: pxToRem(24),
        },
      }
    },
    cardInner: {
      minWidth: pxToRem(270),
      '@media (max-width: 1550px)': {
        minWidth: pxToRem(240),
      },
      '@media (max-width: 600px)': {
        minWidth: pxToRem(305),
      },
      '@media (max-width: 374px)': {
        minWidth: pxToRem(250),
      },
      '&:hover': {
        boxShadow: "0px 5px 30px 0px #0000001A",
        [theme.breakpoints.down('md')]: {
          boxShadow: 'none',
        },
        '& .buttonWrapper': {
          '& .price-cta': {
            backgroundColor: "#0D746D",
          },
        },
      },
      '& .price-cta': {
        backgroundColor: "#0D746D",
        '&:hover': {
          backgroundColor: "#0D746D",
        },
      },
      '& .contentWrapper': {
        padding: `${pxToRem(15)} ${pxToRem(16)} ${pxToRem(12)} ${pxToRem(16)}`,
        borderTop: '1px solid #e9e9e9',
        borderLeft: '1px solid #e9e9e9',
        borderRight: '1px solid #e9e9e9',
        borderRadius: '4px 4px 0px 0px',

        [theme.breakpoints.down('md')]: {
          padding: `${pxToRem(11)} ${pxToRem(16)} ${pxToRem(8)} ${pxToRem(16)}`,
        },
        '& p': {
          minHeight: pxToRem(72),
          display: "-webkit-box",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": 3,
          overflow: "hidden",
        }
      },
      '& .borderSection': {
        height: pxToRem(10),
        display: 'flex',
        alignItems: 'center',
        '& .border': {
          width: '100%',
          borderBottom: '2px dashed #e9e9e9',
          position: 'relative',
          '&::before': {
            content: "''",
            position: 'absolute',
            ...theme.mixins.left(-3),
            top: 0,
            height: pxToRem(4),
            width: pxToRem(10),
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px',
            border: '1px solid #e9e9e9',
            borderBottom: 0,
            backgroundColor: '#fff',
            rotate: '90deg',
            '[dir="rtl"] &': {
              rotate: '270deg',
            },
          },
          '&::after': {
            content: "''",
            position: 'absolute',
            ...theme.mixins.right(-3),
            top: 0,
            height: pxToRem(4),
            width: pxToRem(10),
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px',
            border: '1px solid #e9e9e9',
            borderBottom: 0,
            backgroundColor: '#fff',
            rotate: '270deg',
            '[dir="rtl"] &': {
              rotate: '90deg',
            },
          }
        },
      },
      '& .buttonWrapper': {
        padding: pxToRem(16),
        paddingBottom: pxToRem(14),
        borderBottom: '2px solid #e9e9e9',
        borderLeft: '1px solid #e9e9e9',
        borderRight: '1px solid #e9e9e9',
        [theme.breakpoints.down('md')]: {
          padding: `${pxToRem(12)} ${pxToRem(16)}`,
          paddingBottom: pxToRem(11),
          borderBottom: '1px solid #e9e9e9',
        },
        '& .price-cta': {
          width: '100%',
          justifyContent: 'space-between',
          backgroundColor: '#009086',
          '& .btn-txt': {
            color: '#fff'
          },
          '& svg': {
            fill: '#fff'
          }
        }
      }
    }
  };
});

export default useStyles;
